import React from 'react'
import { Box, Typography, useMediaQuery } from '@mui/material'
import { InfoTitleItem } from './Parameters.styled'
import * as sxStyles from './Parameters.styled'

interface IParameterTitleProps {
  parametersTitle: string
}

export const ParameterTitle: React.FC<IParameterTitleProps> = ({
  parametersTitle,
}) => {
  const smallScreen = useMediaQuery('(max-width:1500px)')

  return (
    <InfoTitleItem>
      <Typography
        sx={smallScreen ? sxStyles.titleStyleSmallScreen : sxStyles.titleStyle}
      >
        {parametersTitle}
      </Typography>
      <Box sx={sxStyles.inputBoxWrapper}>
        <Box sx={sxStyles.valueBoxWrapper}>
          <Typography sx={sxStyles.titleStyle}>Min</Typography>
        </Box>
        <Box sx={sxStyles.valueBoxWrapper}>
          <Typography sx={sxStyles.titleStyle}>Max</Typography>
        </Box>
      </Box>
    </InfoTitleItem>
  )
}
